import { render, staticRenderFns } from "./EmployeesCard.vue?vue&type=template&id=34ba01c6&"
import script from "./EmployeesCard.vue?vue&type=script&lang=js&"
export * from "./EmployeesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports